import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";

export default function CandidateHired() {
  const [rows, setRows] = useState([]);
  const [pick, setPick] = useState(null);
  const [f, setF] = useState({ job_title: "", employer: "", start_date: "" });
  const load = () => api.get("/candidate/introductions").then((r) => setRows(r.data.filter((x) => !x.reported)));
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { await api.post("/candidate/hired", { intro_type: pick.intro_type, intro_id: pick.intro_id, ...f }); toast.success("Congratulations! Thanks for letting us know."); setPick(null); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows.length) return null;
  return (
    <div className="mt-4 border-t pt-4" data-testid="candidate-hired-section">
      <p className="text-sm font-medium">Were you hired through one of these?</p>
      {rows.map((r) => (
        <div key={r.intro_id} className="mt-2 flex items-center justify-between gap-2 text-sm">
          <span className="min-w-0 truncate">{r.recruiter} · {r.org}</span>
          <Button size="sm" variant="outline" onClick={() => setPick(r)} data-testid={`candidate-hired-${r.intro_id}`}>I was hired</Button></div>))}
      <Dialog open={!!pick} onOpenChange={(o) => !o && setPick(null)}>
        <DialogContent className="bg-white sm:max-w-md" data-testid="candidate-hired-dialog">
          <DialogHeader><DialogTitle>Tell us about your new role</DialogTitle></DialogHeader>
          <Input placeholder="Job title" value={f.job_title} onChange={(e) => setF({ ...f, job_title: e.target.value })} data-testid="candidate-hired-title" />
          <Input placeholder="Company" value={f.employer} onChange={(e) => setF({ ...f, employer: e.target.value })} data-testid="candidate-hired-employer" />
          <label className="text-sm font-medium">Start date (optional)<Input type="date" className="mt-1" value={f.start_date} onChange={(e) => setF({ ...f, start_date: e.target.value })} data-testid="candidate-hired-start" /></label>
          <p className="text-xs text-muted-foreground">We'll ask the recruiter to confirm. This never costs you anything.</p>
          <Button disabled={f.job_title.length < 2} onClick={save} data-testid="candidate-hired-submit">Report my hire</Button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
